import { render, staticRenderFns } from "./HeroAnimation.vue?vue&type=template&id=3eaaca70&"
import script from "./HeroAnimation.vue?vue&type=script&lang=js&"
export * from "./HeroAnimation.vue?vue&type=script&lang=js&"
import style0 from "./HeroAnimation.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default,BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default})
